import { Fragment } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ArrowRightOnRectangleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import Avatar from './Avatar';

interface UserMenuProps {
  name?: string;
  email?: string;
  onSignOut: () => void;
}

const UserMenu = ({ name, email, onSignOut }: UserMenuProps) => (
  <Menu as="div" className="relative inline-block text-left">
    <MenuButton className="flex items-center gap-2 rounded-full border border-gray-200 py-1 pl-1 pr-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800 sm:pr-3">
      <Avatar name={name} size="sm" />
      <span className="hidden text-sm font-medium sm:block">{name}</span>
      <ChevronDownIcon className="hidden h-4 w-4 text-gray-500 dark:text-gray-400 sm:block" />
    </MenuButton>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      <MenuItems className="absolute right-0 z-50 mt-2 w-64 origin-top-right rounded-xl border border-gray-200 bg-white py-1 shadow-lg focus:outline-none dark:border-gray-800 dark:bg-gray-900">
        <div className="px-4 py-3">
          <p className="truncate text-sm font-semibold text-gray-800 dark:text-gray-100">{name}</p>
          <p className="truncate text-xs text-gray-500 dark:text-gray-400">{email}</p>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-800" />
        <div className="py-1">
          <MenuItem>
            {({ focus }) => (
              <button
                type="button"
                onClick={onSignOut}
                className={clsx(
                  'flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-200',
                  focus && 'bg-gray-100 dark:bg-gray-800'
                )}
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                Déconnexion
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Transition>
  </Menu>
);

export default UserMenu;
